<template>
  <div class="edit-document-type-tab-content">
    <a-button-group style="margin-bottom: 1.5rem">
      <a-button :type="allButtonType" @click="onDisplayAllClick">Alle documenten</a-button>
      <a-button :type="allUnmappedButtonType" @click="onDisplayOnlyUnmappedClick">Te koppelen documenten</a-button>
    </a-button-group>
    <table class="table">
      <thead>
      <tr>
        <th>Document</th>
        <th class="compact">Grootte</th>
        <th class="compact">DocumentType</th>
      </tr>
      </thead>
      <tbody>
      <template v-if="hasDocumentTypes">
        <DocumentMapToTypeComponent
                v-for="document in filteredDocuments"
                :key="document.id"
                :document="document"
                :document-types="documentTypes"
                v-on:change="onDocumentTypeChanged"
        >
        </DocumentMapToTypeComponent>
      </template>
      </tbody>
    </table>
  </div>
</template>

<script>

import attachableApi from "~/api/attachable";
import documentApi from "~/api/document";
import documentTypeApi from "~/api/document_type";
import DocumentMapToTypeComponent from "~/modules/document/components/MapToTypeComponent";

export default {
  name: "MortgageDocumentTypeOverviewEditComponent",
  props: {
    mortgageId: {
      type: [Number, String],
      required: true,
    }
  },
  components: {
    DocumentMapToTypeComponent
  },
  data() {
    return {
      attachables: [],
      documents: [],
      documentTypes: [],
      displayOnlyUnmapped: false,
    }
  },
  created() {
    this.initMortgage();
    this.initDocumentTypes();
  },
  computed: {
    documentIds() {
      return this.attachables.map(attachable => attachable.child_id);
    },
    hasDocumentTypes() {
      return this.documentTypes.length > 0;
    },
    allButtonType() {
      return this.displayOnlyUnmapped ? 'default' : 'primary';
    },
    allUnmappedButtonType() {
      return this.displayOnlyUnmapped ? 'primary' : 'default';
    },
    filteredDocuments() {
      if (this.displayOnlyUnmapped === true) {
        return this.documents.filter(i => i.document_type_id === null);
      } else {
        return this.documents;
      }
    }
  },
  methods: {
    initMortgage() {
      this.initAttachables();
    },
    initAttachables() {
      attachableApi.getByHasAttachableAndIsAttachableType('mortgage', this.mortgageId, 'document').then(response => {
        this.attachables = response.data;
        this.initDocuments();
      })
    },
    initDocumentTypes() {
      documentTypeApi.getAllWithHDN().then(response => {
        this.documentTypes = response.data;
      })
    },
    initDocuments() {
      documentApi.findAll(this.documentIds).then(response => {
        this.documents = response.data;
      })
    },
    onDocumentTypeChanged(document, documentType) {
      if (typeof documentType === 'undefined') {
        document.document_type_id = null;
      } else {
        document.document_type_id = documentType.id;
      }

      // Update document
      documentApi.update(document);
    },
    onDisplayAllClick() {
      this.displayOnlyUnmapped = false;
    },
    onDisplayOnlyUnmappedClick() {
      this.displayOnlyUnmapped = true;
    },
  }
}
</script>

<style scoped>

</style>